import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { useMedia } from 'react-use'
import { Bookmark, RotateCw as RefreshIcon } from 'react-feather'
import Logo from '../../assets/images/Logo.svg'
import Energiswap from '../../assets/images/Energiswap.svg'
import { TYPE } from '../../Theme'
import Search from '../Search'
import getEnvironmentVar from '../../utils/getEnvironmentVar'
import { useSessionStart } from '../../contexts/Application'
import BottomNav from '../BottomNav'
import Link from '../Link'
import { RowFixed } from '../Row'

const HeaderWrapper = styled.div`
  height: 72px;
  left: 72px;
  display: flex;
  align-items: center;
  justify-content: start;
  text-decoration: none;
  z-index: 10;
  width: 100%;
  box-sizing: border-size;

  @media screen and (max-width: 800px) {
    height: ${({ search }) => (search ? '120px' : '72px')} ;
    width: 95vw;
    flex-wrap: wrap;
  }

  @media screen and (max-width: 600px) {
    height: ${({ search }) => (search ? '100px' : '56px')} ;
  }
`

const NrgIcon = styled(Link)`
  transition: transform 0.3s ease;
  :hover {
    transform: rotate(-5deg);
  }
`

const Polling = styled.div`
  display: flex;
  padding: 8px;
  color: white;
  width: 145px;
  height: 20px;
  border-radius: 8px;
  transition: opacity 0.25s ease;
  background-color: ${({ pollingColor }) => pollingColor};
  box-shadow:inset 0 0 0 999px rgba(0,0,0,0.73);
  align-items: center;
  flex-direction: row;
  margin-right: 1rem;

  :hover {
    cursor: pointer;
    box-shadow:inset 0 0 0 999px rgba(0,0,0,0.36);
  }

  @media screen and (max-width: 1080px) {
    margin-right: 0.6rem;
  }

  @media screen and (max-width: 800px) {
    margin-right: 0;
  }
`

const StyledIcon = styled.div`
  color: ${({ theme }) => theme.text2};
`

const BookmarkIcon = styled(Bookmark)`
  fill: ${({ open }) => open ? '#C3C5CB' : 'none'}
  size: 20;
  :hover {
    cursor: pointer;
    stroke-width: 3;
}
`

const RowFixedTopMobile = styled(RowFixed)`
  margin-left: auto;
  margin-right: 1vw;

  @media screen and (max-width: 1080px) {
    margin-right: 0vw;
  }
`

const LogoImage = styled.img`
  margin-left: 10px; 
  margin-top: 3px;
`

const LogoRow = styled(RowFixed)`
  margin-left: 5px;

  @media screen and (max-width: 768px) {
    margin-left: 2px;
  }
`

const SearchRow = styled(RowFixed)`
  margin-left: 5.5vw;

  @media screen and (max-width: 1080px) {
    margin-left: 1vw;
  }
`

export default function Header({ open, setSavedOpen }) {
  const below1080 = useMedia('(max-width: 1080px)')
  const below800 = useMedia('(max-width: 800px)')
  const below900 = useMedia('(max-width: 900px)')
  const below375 = useMedia('(max-width: 376px)')

  const seconds = useSessionStart()
  const [pollingColor, setPollingColor] = useState('')
  const [time, setTime] = useState('-')
  const [searchVisible, setSearchVisible] = useState(true)
  const EnergiswapUrl = getEnvironmentVar('ENERGISWAP_URL')
  const [prevScrollPos, setPrevScrollPos] = useState(0)

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.pageYOffset
      if (Math.abs(prevScrollPos - currentScrollPos) >= 60) {
        setSearchVisible(prevScrollPos >= currentScrollPos || currentScrollPos < 20)
        setPrevScrollPos(currentScrollPos)
      }
    }
    window.addEventListener("scroll", handleScroll)
    return () =>
      window.removeEventListener("scroll", handleScroll)
  }, [prevScrollPos, setPrevScrollPos, searchVisible])

  const searchBarVisible = () => {
    setPrevScrollPos(window.pageYOffset + 1000)
    setTimeout(() => setSearchVisible(true), 0)
  }

  useEffect(() => {
    let minutes = Math.floor(seconds / 60)
    if (minutes >= 5) {
      setTime(`${minutes}m`)
      setPollingColor('rgb(255, 30, 61)')
    } else if (minutes >= 1) {
      setTime(`${minutes}m`)
      setPollingColor('rgb(255, 229, 116)')
    } else {
      setTime(`${seconds}s`)
      setPollingColor('rgb(0, 230, 118)')
    }
  }, [seconds])

  return (
    <>
      <HeaderWrapper search={searchVisible}>
        <LogoRow>
          <NrgIcon target="_blank" rel="noopener noreferrer" href={EnergiswapUrl}>
            <img width={'30px'} src={Logo} alt="logo" />
          </NrgIcon>
          {!below375 && (
            <Link target="_blank" rel="noopener noreferrer" href={EnergiswapUrl}>
              <LogoImage width={'114px'} src={Energiswap} alt="logo" />
            </Link>
          )}
        </LogoRow>

        {!below800 && <SearchRow>
          <Search small={false} showSearchGlass={true} width={below1080 ? (below900 ? '41vw' : '50vw') : '550px'} />
        </SearchRow>}

        <RowFixedTopMobile>
          <Polling pollingColor={pollingColor} onClick={() => window.location.reload()}>
            <TYPE.light color={'white'}>
              Updated {time} ago <br />
            </TYPE.light>
            <RefreshIcon size={18} style={{ marginLeft: 'auto' }} />
          </Polling>
          {!below800 &&
            <StyledIcon onClick={() => setSavedOpen(!open)}>
              <BookmarkIcon open={open} />
            </StyledIcon>
          }
        </RowFixedTopMobile>

        {below800 && searchVisible && <RowFixed>
          <Search small={false} showSearchGlass={true} width={'95vw'} />
        </RowFixed>}
      </HeaderWrapper>
      {below800 && <BottomNav searchBarVisible={searchBarVisible} />}
    </>
  )
}
